import { useState, useEffect } from 'react'
import Axios from 'axios'
import Chart from 'react-apexcharts'

const params = {
    "Opcion": "6",
    "FIni": "",
    "FFin": ""
}

const IngresosPorCargo = ({ url, headers, FIni, FFin, setLoadingAPIS }) => {

    params.FIni = FIni
    params.FFin = FFin

    const [data, setData] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Axios({
                    method: 'get',
                    url: url,
                    headers: headers,
                    params: params,
                })
                setData(response.data)
                setLoadingAPIS(curr => ({...curr, IngresosPorCargo: true}))
            } catch (err) {
                console.log(err)
            }
        }
        fetchData()
    }, [])

    const objChartPie = pieFormatter(data)

    return (
        <>
            <div className='bg-primarioMira rounded-lg p-5'>
                <h2 className="text-lg font-medium leading-6 text-white">Ingreso por tipo de cargo</h2>
            </div>
            <div className='px-5 pb-5'>    
                <Chart
                    options={objChartPie.options}
                    series={objChartPie.series}
                    height='450px'
                    type="donut"
                />
            </div>
        </>
    )
}


const pieFormatter = (objArr) => {

    const series = []
    const labels = []

    const configObj = {
        options: {
            legend: {
                position: 'bottom',
                labels: {
                    colors: ['#fff'],
                },
                markers: {
                    radius: 3,
                },
            },
            stroke: {
                colors: ['#233044'],
                width: 3,
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '75%',
                        labels: {
                            show: false,
                        }
                    }
                }
            },
            tooltip: {
                y: {
                    formatter: (value) => {
                        return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
                    }
                },
            },
            colors: ['#E68A00', '#4782da', '#FF1D0D', '#2e4b76']
        },
    }

    objArr.map((obj) => {
        series.push(obj.Valores)
        labels.push(obj.Nombre.charAt(0) + obj.Nombre.toLowerCase().slice(1))
    })

    configObj.options.labels = labels
    configObj.series = series

    return configObj
}

export default IngresosPorCargo